import { objectToQueryString } from "common/utils/request/utils";

const addDTFProps = ($form, { formDtfSizes, formDtfImage }) => {
  $($form)
    .find("input[type=tel]")
    // eslint-disable-next-line func-names
    .each(function () {
      const quantity = $(this).val();
      if (quantity) {
        $(this).data("catalog-number", "Jiffy Transfers");
        $(this).data("color", "");
        $(this).data("size", `${formDtfSizes.width}” x ${formDtfSizes.height}”`);
        $(this).data("image", formDtfImage);
      }
    });
};

const createPayload = ($form, { dtfParams, madeParams }) => {
  // For DTF - only show artwork width x height in added popup.
  if (dtfParams?.formDtfSizes?.width && dtfParams?.formDtfSizes?.height) {
    addDTFProps($form, dtfParams);
  }

  const asFormData =
    madeParams.isMade &&
    madeParams.madePayload.length > 0 &&
    madeParams.madePayload.some(item => Boolean(item.preview));

  if (asFormData) {
    const formData = new FormData($form);
    const hash = objectToQueryString({ placements: madeParams.madePayload });
    hash.split("&").forEach(item => {
      const [key, value] = item.split("=");
      formData.append(key, decodeURIComponent(value));
    });
    madeParams.madePayload.forEach((item, index) => {
      const file = item.preview;
      if (file) {
        formData.append(`placements[${index}][preview]`, file);
      }
    });
    return formData;
  }

  let serializedData = $($form).serialize();
  if (madeParams.isMade) {
    const hash = objectToQueryString({ placements: madeParams.madePayload });
    serializedData += `&${hash}`;
  }

  return serializedData;
};

export default createPayload;
